import { useLazyQuery } from '@apollo/client';
import { LIST_WONDER_LINES } from '../../graphql/queries/oneSongWonder/onesongwonder';

const useGetWonderLines = (songId) => {
  const [listWonderLines, { loading, data, error }] = useLazyQuery(
    LIST_WONDER_LINES,
    {
      variables: { filter: { songId } },
      fetchPolicy: 'network-only',
    }
  );

  return {
    listWonderLines,
    loading,
    data,
    error,
  };
};

export default useGetWonderLines;
